import { UserRoleEnum } from '../types/users/userRole';
import UserHandler from 'util/UserHandler';

type CanParams = {
  resource: string;
  action: string;
  params?: any;
};

type CanReturnType = {
  can: boolean;
  reason?: string;
};

const unauthorized = () =>
  Promise.resolve({
    can: false,
    reason: 'Unauthorized',
  });

const authorized = () => Promise.resolve({ can: true });

const checkAuth = (pages: string[], page: string) => {
  const _page = page.split('|');
  let find = -1;
  _page.forEach(p => {
    find = pages.indexOf(p);
    if(find !== -1) return;
  })
  return find !== -1 ? authorized() : unauthorized();
};

const accessControlProvider = {
  can: async ({
    resource,
    action,
    params,
  }: CanParams): Promise<CanReturnType> => {
    const user = UserHandler.getInstance().user;

    const admin: string[] = [ 'dashboard', 'home', 'user', 'ownership','conveyance' ];
    const agency: string[] = ['dashboard', 'user', 'ownership','conveyance'];
    const _private: string[] = ['dashboard', 'ownership'];
    const _user: string[] = ['dashboard', 'home'];

    if (!user) {
      return unauthorized();
    }
    const role = user.role;
    switch (role) {
      case UserRoleEnum.Admin:
        return checkAuth(admin, resource);
      case UserRoleEnum.Agency:
        return checkAuth(agency, resource);
      case UserRoleEnum.Private:
        return checkAuth(_private, resource);
      case UserRoleEnum.User:
        return checkAuth(_user, resource);
    }
    return unauthorized();
  },
};

export default accessControlProvider;
